import React from 'react';
import { CardListFieldsFragment } from "@src/generated/graphql";
import { highlightBracketedText, highlightUnderscoreText } from 'src/utils/utils';

type EnterpriseFeaturesGridProps = {
  content: CardListFieldsFragment;
  className?: string;
};

const EnterpriseFeaturesGrid = ({ content, className }:EnterpriseFeaturesGridProps) => {
  const { title, cardsCollection, description } = content;
  const items = cardsCollection?.items ?? [];

  if (!content) return null;

  return (
    <section className={`enterprise-features ${className}`}>
      <div className="enterprise-features__header">
        <div style={{display:"flex", alignItems:"center" , justifyContent:"center" , flexDirection:"column"}}>
        <h2
          className="enterprise-features__title"
          dangerouslySetInnerHTML={{
            __html: highlightBracketedText(title ?? "", "bold"),
          }}
        />
        <p 
          className="enterprise-features__description"
          dangerouslySetInnerHTML={{
            __html: highlightUnderscoreText(description ?? ""),
          }}
        />
        </div>
      </div>

      <div className="enterprise-features__grid">
        {items.map((card, index) => (
          <div key={index} className="enterprise-features__item">
            {card?.cardIcon?.url && (
              <img 
                src={card?.cardIcon.url} 
                alt={card?.cardIcon?.title ?? ""}
                className="enterprise-features__icon"
              />
            )}
            <div className="enterprise-features__content">
              <h3 
                className="enterprise-features__item-title"
                dangerouslySetInnerHTML={{
                  __html: highlightUnderscoreText(card?.cardTitle ?? ""),
                }}
              />
              <div 
                className="enterprise-features__item-description "
                dangerouslySetInnerHTML={{ 
                  __html: highlightUnderscoreText(
                    card?.cardDescription?.json?.content[0]?.content[0]?.value ?? ""
                  )
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EnterpriseFeaturesGrid;